module.exports = __webpack_public_path__ + "img/Bank Nowy S.A. .ca29d64b.png";